import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { reportService } from 'services';
import download from 'downloadjs';

const initialState = {
  dataStatusList: {},
  statusGetList: '',
  urlDownload: {},
  statusGetUrlDownload: '',
  statusGenerate: ''
};

export const getStatusList = createAsyncThunk(
  'report/fetchStatusList',
  async (data) => {
    const response = await reportService.reportStatusList(data);
    return response;
  }
);

export const getUrlDownload = createAsyncThunk(
  'report/fetchUrlDownload',
  async (data) => {
    const response = await reportService.getUrlDownload(data);
    if (response) download(response, data.fileName);

    return response;
  }
);

export const generateData = createAsyncThunk(
  'report/fetchGenerate',
  async (data) => {
    const response = await reportService.generate(data);
    return response;
  }
);

export const reportSlice = createSlice({
  name: 'report',
  initialState: initialState,
  reducers: {
    resetData: (state, action) => {
      const payload = action.payload;
      if(typeof payload === 'string'){
        state[payload] = initialState[payload];
      }else if(Array.isArray(payload)){
        payload.forEach(item => 
          state[item] = initialState[item]
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStatusList.pending, (state) => {
        state.statusGetList = 'loading';
      })
      .addCase(getStatusList.fulfilled, (state, action) => {
        state.statusGetList = 'success';
        state.dataStatusList = action.payload;
      })
      .addCase(getStatusList.rejected, (state) => {
        state.statusGetList = 'error';
      })
      .addCase(getUrlDownload.pending, (state) => {
        state.statusGetUrlDownload = 'loading';
      })
      .addCase(getUrlDownload.fulfilled, (state, action) => {
        state.statusGetUrlDownload = 'success';
        state.urlDownload = action.payload;
      })
      .addCase(getUrlDownload.rejected, (state) => {
        state.statusGetUrlDownload = 'error';
      })
      .addCase(generateData.pending, (state) => {
        state.statusGenerate = 'loading';
      })
      .addCase(generateData.fulfilled, (state) => {
        state.statusGenerate = 'success';
      })
      .addCase(generateData.rejected, (state) => {
        state.statusGenerate = 'error';
      });
  }
});

export const { resetData } = reportSlice.actions;

const reportReducer = reportSlice.reducer;
export default reportReducer;